/*
 * 接口统一集成模块
 */
import * as found from './moudules/found'
import * as send from './moudules/send'
import * as mobile from './moudules/mobile'
import * as login from './moudules/login'

// 默认全部导出
export default {
  found,
  send,
  mobile,
  login
}



// WEBPACK FOOTER //
// ./src/http/api.js